import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Configs from './Configs';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'es',
    debug: Configs.devEnvironment ? true : false,
    returnNull: false,

    // No `public/locales/en-US/` bundle; map US English to the shared `en` catalog.
    detection: {
      convertDetectedLanguage: (lng) => (lng === 'en-US' ? 'en' : lng),
    },

    // Default namespace configuration
    defaultNS: 'translation',
    ns: [
      'translation',
      'filterWidget',
      'trust-center',
      'careers',
      'performance',
      'pulse',
      'reportingPeriod',
      'employeeVisibilityScopeVisibility',
      'learning',
      'goals',
      'news',
      'launch-announcements',
      'settings',
      'recruitment',
      'compliance',
      'customerSatisfaction',
      'admin',
    ],

    backend: {
      // Always read files from a folder that exists (avoids HTML/404 bodies that fail JSON.parse).
      loadPath: (languages, namespaces) => {
        const raw = languages?.[0] ?? 'es';
        const lng = raw === 'en-US' ? 'en' : raw;
        const ns = namespaces?.[0] ?? 'translation';
        return `/locales/${lng}/${ns}.json`;
      },
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
